@if (branding) {
  <div class="print-only mb-5">
    <img class="logo pull-left" [src]="branding.logoUrl" />
    <span class="title">{{ branding.title }}</span>
    <span class="subtitle">{{ branding.subTitle }}</span>
  </div>
}
<nav>
  <ul class="breadcrumb">
    <li class="breadcrumb-item"><a href="#" (click)="goBack($event)"><i class="fa fa-arrow-circle-left" style="width: 20px;"></i>Back to Search Results</a></li>
    <li class="ms-auto"><a href="#" (click)="print($event)"><i class="fa fa-print" style="width: 20px;"></i>Print</a></li>
    <li class="ms-3">@if (externalLinks) {
      <a [href]="externalLinks.dataBankResourcesUrl" target="_blank"><i class="fa fa-external-link" style="width: 20px;"></i>DNA Data Bank Resources</a>
    }</li>
  </ul>
</nav>
<div class="text-center">
  <h1>DNA Sample Details</h1>
</div>
@if (errorMessage) {
  <div class="col-12 col-lg-6 offset-lg-3 alert alert-danger">{{errorMessage}}</div>
}
@if (sample) {
  <app-sample-display [dnaSample]="sample"></app-sample-display>
}
@if (sample && showSampleCorrection) {
  <div class="mt-3 sample-correction-link">
    <span>If you believe any of the information on this screen is incorrect, </span><button type="button" class="btn btn-link" (click)="onSampleCorrectionClick(sample.id)">Submit a Sample Correction</button><span>.</span>
  </div>
}
<ng-template #arresteeWarning let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Arrestee Warning</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('X click')"></button>
  </div>
  <div class="modal-body">
    <p style="font-size: 1.2rem">This sample was collected based on a qualifying arrest charge.</p>
    <p style="font-size: 1.2rem">When an existing DNA Data Bank sample was collected due to a qualifying arrest charge, the sample may be removed from the DNA Data Bank and destroyed pursuant to @if (externalLinks) {
      <a [href]="externalLinks.arresteeCodeUrl" target="_blank">§ 19.2-310.2:1.</a>
    }</p>
    <p style="font-size: 1.2rem">If the DNA sample is being collected for a qualifying misdemeanor or felony conviction and this arrestee warning appears, the best practice is to collect and send the new sample based on the conviction.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" ngbAutoFocus (click)="modal.dismiss()">OK</button>
  </div>
</ng-template>
